<script>
  // Side-by-side candidate pick for an ambiguous scan (spec §5): sku, item
  // name, size, status and rack location — rack only when there is one. Picking
  // resolves the scan and leaves an undo-able tombstone in the parent, so there
  // are no picked/no-match badges here.
  import StatusTag from "./StatusTag.svelte";
  import { branchNames, pickReview } from "./store";

  export let scan; // {value, kind, candidates}

  $: branchName = (id) => $branchNames[id] || `Branch ${id}`;
</script>

<div class="border rounded p-2 mb-3 bg-white">
  <div class="d-flex align-items-center flex-wrap mb-2">
    <strong class="me-2"><i class="fas fa-{scan.kind === 'sku' ? 'tag' : 'barcode'} me-1" />{scan.value}</strong>
    <span class="text-muted small">
      This scanned {scan.kind === "sku" ? "SKU" : "barcode"} is used by
      <strong>{scan.candidates.length}</strong> units — pick the one you scanned.
    </span>
    <button
      class="btn btn-sm btn-outline-secondary ms-auto"
      title="Record the scan without tying it to any unit"
      on:click={() => pickReview(scan.value, "none")}
    >
      None of these
    </button>
  </div>
  <div class="d-flex gap-2 flex-wrap">
    {#each scan.candidates as c}
      <button class="candidate card p-2 text-start" on:click={() => pickReview(scan.value, c.id)}>
        <div class="fw-bold small">{c.itemName || "(no item)"}</div>
        <div class="small text-muted"><span><i class="fas fa-tag me-1" /></span>{c.sku}</div>
        <div class="small">
          Size {c.size || "—"} · <StatusTag status={c.status} />
        </div>
        <div class="small text-muted">
          {branchName(c.branchId)}{#if c.rack}<span> · Rack {c.rack}</span>{/if}
        </div>
      </button>
    {/each}
  </div>
</div>

<style>
  .candidate {
    width: 15rem;
    cursor: pointer;
    border: 2px solid var(--bs-border-color, #dee2e6);
    background: #fff;
  }
  .candidate:hover {
    border-color: var(--bs-success, #198754);
    background: #f0fff4;
  }
</style>
